import ProfileCell from "PFApp/components/table/profile_cell";
import useBookingCategories from "PFCore/hooks/use_booking_categories";
import { BookingApproval } from "PFTypes";
import React from "react";
import { useTranslation } from "react-i18next";

import CategoryBadge from "../../../../components/category_badge";
import NoPermissions from "../../no_permissions";
import css from "../modals.module.scss";

type IProps = {
  data: BookingApproval | BookingApproval[];
};

const Table = ({
  bookingTitle,
  engagementName,
  activityName,
  profileChildren,
  categoryChildren
}: {
  bookingTitle?: React.ReactNode;
  engagementName?: string;
  activityName?: string;
  profileChildren: React.ReactNode;
  categoryChildren: React.ReactNode;
}) => {
  const { t } = useTranslation("translation");

  return (
    <div className={css.table} style={{ marginBottom: 30 }}>
      <div className={css.cell} style={{ width: "20%" }}>
        <div>{t("title")}</div>
        <div className={css.bold}>{bookingTitle || "-"}</div>
      </div>
      <div className={css.cell} style={{ width: "20%" }}>
        <div>{t("engagement")}</div>
        <div className={css.bold}>{engagementName || "-"}</div>
      </div>
      <div className={css.cell} style={{ width: "20%" }}>
        <div>{t("role")}</div>
        <div className={css.bold}>{activityName || "-"}</div>
      </div>
      <div className={css.cell} style={{ width: "20%" }}>
        <div>{t("resource")}</div>
        {profileChildren}
      </div>
      <div className={css.cell} style={{ width: "20%" }}>
        <div>{t("category")}</div>
        {categoryChildren}
      </div>
    </div>
  );
};
const ApprovalTable = ({ data }: IProps) => {
  const { t } = useTranslation();
  const { getCategory } = useBookingCategories();

  if (Array.isArray(data) && data.length > 1) {
    const multipleString = t("multiple");
    return (
      <Table
        bookingTitle={multipleString}
        engagementName={multipleString}
        activityName={multipleString}
        categoryChildren={multipleString}
        profileChildren={multipleString}
      />
    );
  }
  const item: BookingApproval = Array.isArray(data) ? data[0] : data;
  const { activity, booking, profile } = item;
  const isBookingCategoryHidden = !getCategory(booking);
  return (
    <Table
      bookingTitle={isBookingCategoryHidden ? <NoPermissions /> : booking.title}
      engagementName={activity?.engagement?.name}
      activityName={activity?.name}
      categoryChildren={
        isBookingCategoryHidden ? (
          <NoPermissions />
        ) : (
          <CategoryBadge categoryId={booking.booking_category_id} />
        )
      }
      profileChildren={isBookingCategoryHidden ? <NoPermissions /> : <ProfileCell profile={profile} />}
    />
  );
};

export default ApprovalTable;
